module.exports = __webpack_public_path__ + "static/scale-model-of-sprinkler-factory-in-worcester-massachusetts-4192ff8dc6058b96bfc5ab76a5246593.png";